import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import RatingSmiley from '../../rating-smiley';

import { Rating } from '../../../../../../components/rating/src/types';
import { formatReviewCount } from './utils';

import * as S from './styles';

type OwnProps = {
  featured: boolean;
  showPriceListRatingExperiment: boolean;
  rating?: Rating;
  reviewCount: number;
  storeLink: string;
};

const StoreReviews = ({
  featured,
  showPriceListRatingExperiment,
  rating,
  reviewCount,
  storeLink,
}: OwnProps) => {
  const { t } = useAppContext();

  return (
    <S.StoreReviews>
      {showPriceListRatingExperiment && rating && (
        <>
          <RatingSmiley
            featured={featured}
            rating={rating}
            showPriceListRatingExperiment={showPriceListRatingExperiment}
            scoreVisibility="row"
          />
          <S.Separator>|</S.Separator>
        </>
      )}
      <S.StoreLink
        color="link"
        href={storeLink}
        ariaLabel={t('reviews', 'rating.n-reviews', {
          n: formatReviewCount(reviewCount),
        })}
        data-test="StoreInfoLink"
      >
        {`${t('reviews', 'rating.n-reviews', {
          n: formatReviewCount(reviewCount),
        })}`}
      </S.StoreLink>
    </S.StoreReviews>
  );
};

export default StoreReviews;
